import { useI18n } from '@/i18n'
import { cn } from '@/lib/cn'

/** हि / EN segmented toggle. Hindi is the default; English stays visible as the second line. */
export function LanguageToggle({ className }: { className?: string }) {
  const { locale, setLocale, t } = useI18n()
  return (
    <div
      role="group"
      aria-label={t('common.language')}
      className={cn('inline-flex rounded-chip border border-rule bg-surface p-0.5', className)}
    >
      {(['hi', 'en'] as const).map((l) => (
        <button
          key={l}
          type="button"
          lang={l}
          aria-pressed={locale === l}
          onClick={() => setLocale(l)}
          className={cn(
            'h-8 min-w-[40px] rounded-chip px-2 text-[13px] font-semibold transition-colors',
            locale === l ? 'bg-ink text-paper' : 'text-ink-soft hover:text-ink',
          )}
        >
          {l === 'hi' ? 'हि' : 'EN'}
        </button>
      ))}
    </div>
  )
}
